import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          organizationId: Yup.string()
                                                             .required('Organization context is missing'),
                                          accountId: Yup.string()
                                                        .required('Required'),
                                          organizationAccountStatus: Yup.string()
                                                                        .required('Required'),
                                      });
